/* PELUX · Chantier conversion du 14/10 — zone « bas » de la fiche du harnais
   (thème de test « page parfaite », review/cro-2026-10-14/CHARTE.md).
   Bas de page et relances : guide des tailles, caractéristiques, étapes, 3D, FAQ, « complète », CTA final, barre d'achat collante, pop-up de sortie.
   Chargé en defer seulement sur la fiche du harnais, après pelux-preuve.js (layout/theme.liquid).
   Custom elements ou délégation sur le document : les blocs re-rendus (variantes, prix) remplacent
   leur DOM à chaque changement de variante.

   RAPPELS DU BAS DE PAGE — on RECOPIE le haut de fiche, on ne calcule rien :
     - la vignette « Il n'en reste que X » de la taille cochée en haut (zone « haut » :
       snippets/product-variant-picker.liquid, stock réel suivi ou lot gardé) :
         · au-dessus de la barre collante (réglage « Rappel du stock bas », data-cro-bas-stock),
         · sous la taille cochée du CTA final (réglage « Rappels de la fiche », data-cro-bas-rappels) ;
     - la ligne « Pour Noël : commande d'ici le … » (zone « achat » :
       snippets/pelux-delivery-estimate.liquid), sous le bouton du CTA final.
   Même nœud cloné = mêmes mots, même chiffre, même garde des lots ([data-pelux-lot]
   vient avec). Le haut n'affiche rien → aucune copie : jamais de
   chiffre fabriqué ici. Aucun texte en dur dans ce fichier.

   Le CTA final et le haut de fiche ne font plus qu'une variante : une taille choisie en bas coche
   la même taille en haut (re-rendu Dawn, comme les pastilles du modèle 3D) — la vignette de stock
   suit alors la taille choisie en bas. */
(function () {
  'use strict';
  if (window.peluxCroBas) return;
  window.peluxCroBas = true;

  var COPIE = 'cro-bas-copie';

  /* Sélecteur de variantes du haut. Après un changement, Dawn garde 500 ms l'ancien
     <variant-selects> (masqué) à côté du nouveau, inséré AVANT lui : le premier est le bon. */
  function selecteur() {
    return document.querySelector('variant-selects[data-section]');
  }

  /* Identifiant de la variante du formulaire du haut. */
  function idHaut() {
    var vs = selecteur();
    var form = vs && document.getElementById('product-form-' + vs.dataset.section);
    var input = form && form.querySelector('[name="id"]');
    return input ? String(input.value) : null;
  }

  /* La vignette de stock du haut, si elle existe : le nœud à cloner, sa phrase complète pour les
     lecteurs d'écran (« Il n'en reste que 6 en M »), son statut. */
  function stockHaut() {
    var vs = selecteur();
    var ruban = vs && vs.querySelector('.pelux-stock-ruban');
    var bulle = ruban && ruban.querySelector('.pelux-stock-ruban__bulle');
    if (!bulle || !bulle.textContent.trim()) return null;
    var phrase = bulle.textContent.replace(/\s+/g, ' ').trim();
    var statut = vs.querySelector('p[role="status"]');
    if (statut) phrase = statut.textContent.replace(/\s+/g, ' ').trim() || phrase;
    return { ruban: ruban, phrase: phrase, lot: ruban.hasAttribute('data-pelux-lot'), id: idHaut() };
  }

  function cloner(s) {
    var c = s.ruban.cloneNode(true);
    c.classList.add(COPIE);
    c.setAttribute('aria-hidden', 'true');
    return c;
  }

  /* Phrase pour les lecteurs d'écran (la vignette est aria-hidden), gardée comme elle. */
  function phraseLecteur(el, s) {
    el.textContent = s ? s.phrase : '';
    if (s && s.lot) el.setAttribute('data-pelux-lot', '');
    else el.removeAttribute('data-pelux-lot');
  }

  /* ---------------------------------------------------------------------------
     Barre collante : la vignette se pose au-dessus de la barre, côté bouton, sans lui ajouter
     de hauteur ; elle se déroule de nouveau à chaque apparition de la barre.
     ------------------------------------------------------------------------ */
  function barre() {
    var b = document.querySelector('sticky-atc[data-cro-bas-stock]');
    if (!b) return;
    var s = stockHaut();
    var cle = s ? s.phrase + '|' + s.lot : '';
    var ancienne = b.querySelector(':scope > .' + COPIE);
    if (b.getAttribute('data-cro-bas-cle') === cle && (ancienne || !s)) return;
    b.setAttribute('data-cro-bas-cle', cle);
    if (ancienne) ancienne.remove();
    var lecteur = b.querySelector(':scope > [data-cro-bas-lecteur]');
    if (!s) {
      if (lecteur) lecteur.remove();
      return;
    }
    b.appendChild(cloner(s));
    if (!lecteur) {
      lecteur = document.createElement('span');
      lecteur.className = 'visually-hidden';
      lecteur.setAttribute('data-cro-bas-lecteur', '');
      b.appendChild(lecteur);
    }
    phraseLecteur(lecteur, s);
  }

  function suivreBarre() {
    var b = document.querySelector('sticky-atc[data-cro-bas-stock]');
    if (!b || !('MutationObserver' in window)) return;
    var visible = b.classList.contains('is-visible');
    new MutationObserver(function () {
      var maintenant = b.classList.contains('is-visible');
      if (maintenant && !visible) {
        barre();
        var c = b.querySelector(':scope > .' + COPIE);
        if (c) c.replaceWith(c.cloneNode(true)); // rejoue l'animation de la vignette
      }
      visible = maintenant;
    }).observe(b, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------------------------------------------------------------------------
     CTA final : vignette sous la taille cochée (seulement si c'est la variante du haut, celle
     dont on connaît le stock) et ligne de Noël sous le bouton.
     ------------------------------------------------------------------------ */
  function finalAtc() {
    return document.querySelector('pelux-final-atc[data-cro-bas-rappels]');
  }

  function variantes(f) {
    if (f.croBasVariantes) return f.croBasVariantes;
    var parId = {};
    try {
      JSON.parse(f.querySelector('[data-final-variants]').textContent).forEach(function (v) {
        parId[String(v.id)] = v;
      });
    } catch (e) {
      parId = {};
    }
    f.croBasVariantes = parId;
    return parId;
  }

  function final() {
    var f = finalAtc();
    if (!f) return;
    var s = stockHaut();
    var choisie = f.querySelector('.pelux-final__size.is-selected');
    var vHaut = s && s.id ? variantes(f)[s.id] : null;
    var meme = !!(s && choisie && vHaut && vHaut.s === choisie.dataset.size);
    var cle = meme ? s.phrase + '|' + s.lot + '|' + choisie.dataset.size : '';
    var ancienne = f.querySelector('.' + COPIE);
    if (f.getAttribute('data-cro-bas-cle') === cle && (ancienne || !meme)) return;
    f.setAttribute('data-cro-bas-cle', cle);
    if (ancienne) ancienne.remove();
    var rangee = f.querySelector('.pelux-final__sizes');
    var lecteur = f.querySelector('[data-cro-bas-lecteur]');
    if (!lecteur && rangee) {
      lecteur = document.createElement('p');
      lecteur.className = 'visually-hidden';
      lecteur.setAttribute('data-cro-bas-lecteur', '');
      lecteur.setAttribute('aria-live', 'polite');
      rangee.after(lecteur);
    }
    if (!meme) {
      if (lecteur) phraseLecteur(lecteur, null);
      return;
    }
    choisie.appendChild(cloner(s));
    if (lecteur) phraseLecteur(lecteur, s);
  }

  /* La date limite de Noël ne dépend pas de la variante : recopiée une fois, telle que le haut
     l'affiche (rien s'il ne l'affiche pas : hors période, ou ligne absente). */
  function noel() {
    var f = finalAtc();
    if (!f || f.querySelector('.cro-bas-noel')) return;
    var source = document.querySelector('.product__info-container [data-pelux-noel]');
    var texte = source && source.querySelector('.pelux-delivery__noel');
    if (!source || source.hidden || !texte || !texte.textContent.trim()) return;
    var c = source.cloneNode(true);
    ['id', 'hidden', 'data-pelux-noel', 'data-des', 'data-modele', 'data-langue', 'data-filled'].forEach(function (a) {
      c.removeAttribute(a);
    });
    c.classList.add('cro-bas-noel');
    var bouton = f.querySelector('[data-final-add]');
    if (bouton) bouton.after(c);
  }

  /* Une taille choisie dans le CTA final coche la même taille en haut de fiche : une seule
     variante pour toute la page (prix, stock, barre, adresse ?variant=). Le re-rendu de Dawn
     redonne le focus à la pastille du haut, sans défiler (assets/product-info.js) : le focus
     clavier revient ensuite au CTA final. */
  var focusARendre = null;
  /* La pastille touchée garde sa place à l'écran. Le haut de fiche change de hauteur avec la
     variante (vignette de stock et sa place réservée, 36 px) : Chrome et Firefox compensent seuls
     (ancrage du défilement), Safari non — la page y sautait de 36 px (fusion du 14/10). On ne
     compense que le déplacement du contenu, jamais le défilement fait par le client entre-temps. */
  var ancrageNatif = !!(window.CSS && CSS.supports && CSS.supports('overflow-anchor', 'auto'));
  var ancre = null;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('pelux-final-atc[data-cro-bas-rappels] .pelux-final__size');
    if (!btn) return;
    var avaitLeFocus = document.activeElement === btn;
    setTimeout(function () {
      // Après le gestionnaire du CTA final : une taille indisponible n'est pas cochée.
      if (!btn.classList.contains('is-selected')) return;
      var vs = selecteur();
      var nom = vs && vs.getAttribute('data-pelux-taille-defaut');
      if (!nom) {
        final();
        return;
      }
      var radio = Array.prototype.find.call(vs.querySelectorAll('input[type="radio"]'), function (r) {
        return r.value === btn.dataset.size && r.name.indexOf(nom + '-') === 0;
      });
      if (!radio || radio.checked) {
        final();
        return;
      }
      focusARendre = avaitLeFocus ? btn : null;
      ancre = ancrageNatif ? null : { el: btn, y: btn.getBoundingClientRect().top + window.scrollY };
      radio.click();
      final(); // la variante du haut n'est pas encore la nouvelle : pas de vignette en attendant
    }, 0);
  });

  /* Variante du haut changée (Dawn signale le nouvel identifiant après le re-rendu). */
  document.addEventListener('change', function (e) {
    if (!e.target || e.target.name !== 'id') return;
    setTimeout(function () {
      barre();
      final();
      if (ancre) {
        var a = ancre;
        ancre = null;
        if (a.el.isConnected) {
          var decalage = a.el.getBoundingClientRect().top + window.scrollY - a.y;
          if (Math.abs(decalage) > 1) window.scrollBy(0, decalage);
        }
      }
      if (focusARendre) {
        var b = focusARendre;
        focusARendre = null;
        if (b.isConnected) b.focus({ preventScroll: true });
      }
    }, 0);
  });

  function tout() {
    barre();
    final();
    noel();
  }

  function demarrer() {
    tout();
    suivreBarre();
    // Le CTA final coche sa taille quand son élément est défini : relire ensuite.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('pelux-final-atc').then(function () {
        setTimeout(tout, 0);
      });
    }
    window.addEventListener('load', tout);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
